import React from "react";
import NotFound from "@/pages/NotFound";
import AccessDenied from "@/pages/AccessDenied";
import { useAuth } from "../../lib/auth";
import { ARCHITECT_ROLES, usePhaseFeature } from "../../lib/phaseFeatures";

export default function ArchitectGate({ children }) {
  const { user } = useAuth();
  const feature = usePhaseFeature(3, user?.id);
  if (!feature) {
    return <div className="p-8 text-sm font-nav text-erf-dark/70" data-testid="phase3-gate-loading">Loading…</div>;
  }
  if (!ARCHITECT_ROLES.includes(user?.role_key)) return <AccessDenied />; // B2a: role check first → 403 page (no module-state leak)
  if (!feature.enabled) return <NotFound />;
  return children;
}

export function ArchDisclaimer({ text }) {
  return (
    <div role="note" data-testid="phase3-disclaimer"
      className="mb-5 rounded-xl border border-[#B45309]/40 bg-[#FFF7E6] px-4 py-3 text-sm font-nav text-[#5C3A06]">
      <strong>Not professional approval.</strong> {text}
    </div>
  );
}
